import React from "react"
import Fade from "react-reveal/Fade"

import {
  Wrapper,
  Inner,
  Dots,
  Dot,
  Row,
  Col12,
  Heading3,
  Heading1White,
} from "../../styles/styles"

const Section1 = () => (
  <Wrapper>
    <Inner>
      <Row>
        <Col12>
          <Fade>
            <Heading3>Round 1.</Heading3>
          </Fade>
          <Fade>
            <Heading1White>SO MANY FLAVOURS AND YOU CHOOSE TO BE SALTY.</Heading1White>
          </Fade>
          <Fade>
            <Dots>
              <Dot />
              <Dot />
              <Dot />
            </Dots>
          </Fade>
        </Col12>
      </Row>
    </Inner>
  </Wrapper>
)

export default Section1
